<template>
<div>
    <usergroups :usergroups="userGroups" @userGroupChange="getUserGroups()"></usergroups>
</div>
  
</template>

<script>
import Api from "@/services/Api";
import UserGroups from '@/components/UserGroups.vue';

export default {
    
  components: {
    usergroups: UserGroups
  },
  data(){
      return{
          userGroups: []
      }
  },
  created(){
      this.initialize()
  },
  methods: {
      initialize(){
          this.getUserGroups()
      },
      getUserGroups(){
          Api()
          .get('/userGroup')
          .then(response=>{
              this.userGroups=response.data
          })
      }
  }
}
</script>

<style>

</style>